import {
  ref,
  get,
  child,
  serverTimestamp,
  set,
  push,
} from "firebase/database";
import { database } from ".";

export function readData(node) {
  return new Promise(async (resolve, reject) => {
    try {
      const dbRef = ref(database);
      const snapshot = await get(child(dbRef, node));
      if (snapshot.exists()) {
        resolve(snapshot.val());
      } else {
        console.log("No data available");
        resolve(null);
      }
    } catch (error) {
      console.error(error);
      reject(error);
    }
  });
}

export function writeDataInDB(node, data) {
  return new Promise(async (resolve, reject) => {
    try {
      const dataRef = ref(database, node);

      // Push each data object to the node, generating a unique key for each one
      const newDataRef = push(dataRef);
      await set(newDataRef, { ...data, timestamp: serverTimestamp() });

      resolve(newDataRef.key); // return the unique key of the new data
    } catch (error) {
      console.error(error);
      reject(error);
    }
  });
}
